/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoAccountSessionLogListAccountSessionLogData model module.
 * @module model/LogControllerDtoAccountSessionLogListAccountSessionLogData
 * @version 1.0
 */
class LogControllerDtoAccountSessionLogListAccountSessionLogData {
    /**
     * Constructs a new <code>LogControllerDtoAccountSessionLogListAccountSessionLogData</code>.
     * @alias module:model/LogControllerDtoAccountSessionLogListAccountSessionLogData
     */
    constructor() { 
        
        LogControllerDtoAccountSessionLogListAccountSessionLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoAccountSessionLogListAccountSessionLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoAccountSessionLogListAccountSessionLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoAccountSessionLogListAccountSessionLogData} The populated <code>LogControllerDtoAccountSessionLogListAccountSessionLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoAccountSessionLogListAccountSessionLogData();

            if (data.hasOwnProperty('sessionNo')) {
                obj['sessionNo'] = ApiClient.convertToType(data['sessionNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('userType')) {
                obj['userType'] = ApiClient.convertToType(data['userType'], 'Number');
            }
            if (data.hasOwnProperty('startedAt')) {
                obj['startedAt'] = ApiClient.convertToType(data['startedAt'], 'Date');
            }
            if (data.hasOwnProperty('endedAt')) {
                obj['endedAt'] = ApiClient.convertToType(data['endedAt'], 'Date');
            }
            if (data.hasOwnProperty('userAddr')) {
                obj['userAddr'] = ApiClient.convertToType(data['userAddr'], 'String');
            }
            if (data.hasOwnProperty('userDeviceId')) {
                obj['userDeviceId'] = ApiClient.convertToType(data['userDeviceId'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoAccountSessionLogListAccountSessionLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoAccountSessionLogListAccountSessionLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['userAddr'] && !(typeof data['userAddr'] === 'string' || data['userAddr'] instanceof String)) {
            throw new Error("Expected the field `userAddr` to be a primitive type in the JSON string but got " + data['userAddr']);
        }
        // ensure the json data is a string
        if (data['userDeviceId'] && !(typeof data['userDeviceId'] === 'string' || data['userDeviceId'] instanceof String)) {
            throw new Error("Expected the field `userDeviceId` to be a primitive type in the JSON string but got " + data['userDeviceId']);
        }

        return true;
    }


}



/**
 * @member {Number} sessionNo
 */
LogControllerDtoAccountSessionLogListAccountSessionLogData.prototype['sessionNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoAccountSessionLogListAccountSessionLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoAccountSessionLogListAccountSessionLogData.prototype['email'] = undefined;

/**
 * @member {Number} userType
 */
LogControllerDtoAccountSessionLogListAccountSessionLogData.prototype['userType'] = undefined;

/**
 * @member {Date} startedAt
 */
LogControllerDtoAccountSessionLogListAccountSessionLogData.prototype['startedAt'] = undefined;

/**
 * @member {Date} endedAt
 */
LogControllerDtoAccountSessionLogListAccountSessionLogData.prototype['endedAt'] = undefined;

/**
 * @member {String} userAddr
 */
LogControllerDtoAccountSessionLogListAccountSessionLogData.prototype['userAddr'] = undefined;

/**
 * @member {String} userDeviceId
 */
LogControllerDtoAccountSessionLogListAccountSessionLogData.prototype['userDeviceId'] = undefined;






export default LogControllerDtoAccountSessionLogListAccountSessionLogData;

